import { useOutletContext } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

function SettingsDashboard() {
    const { socket, config } = useOutletContext()
    //const [config, setConfig] = useState({});

    const [themeOptions, setThemeOptions] = useState([])

    function updateTheme(data) {
        socket.emit("updateTheme", { ...config, ...data })
    }

    useEffect(() => {
        socket.emit('registerSettings')

        const host = process.env.NODE_ENV === 'production' ? window.location.host : `${window.location.hostname}:3001`

        fetch(`${window.location.protocol}//${host}/api/themes`)
            .then(response => response.json())
            .then(data => {
                setThemeOptions(data)
            })
    }, [])

    return (
        <div>
            <h1>Themes</h1>
            <select value={config.cssTheme} onChange={(e) => updateTheme({ cssTheme: e.target.value })} id="theme" name="theme">
                {themeOptions.map(theme => <option value={theme}>{theme}</option>)}
            </select>
        </div>
    )
}

export default SettingsDashboard;